<template>
  <div>
    <li
      class="product-row food-products"
      :style="{ 'background-color': '#FFFFFF' }"
    >
      <div class="flex-wrapper">
        <div class="menu-group-left-box">
          <h4
            class="product-name mt-1"
            :style="{ color: listItemNameColorTheme }"
          >
            {{ translate("name", menuGroup) }}
          </h4>
          <v-btn
            class="admin-navigation-back ver-menu-btn"
            rounded
            small
            color="white"
            text
            :style="[
              { 'background-color': '#8a6749' },
              { color: this.colorsGeneralPrimary },
              { border: `4px solid ${this.colorsGeneralPrimary}` }
            ]"
            @click="openProductGroupDialog"
            >Ver Menu
          </v-btn>
        </div>
        <div class="product-meta">
          <ProductGroupDialog
            :menuGroup="menuGroup"
            :drinks="drinks"
            :dessert="dessert"
            :starters="starter"
            :maincourse="maincourse"
            :isAdmin="isAdmin"
            ref="productGroupDialog"
          ></ProductGroupDialog>
          <AddToCartGroupProduct
            :menuGroup="menuGroup"
            :drinks="drinks"
            :dessert="dessert"
            :starters="starter"
            :maincourse="maincourse"
            :isAdmin="isAdmin"
          ></AddToCartGroupProduct>
        </div>
      </div>

      <div
        class="description"
        :style="{ color: listItemDescriptionColorTheme }"
      >
        {{ translate("description", menuGroup) }}
      </div>
    </li>
  </div>
</template>

<script>
import AddToCartGroupProduct from "../../cart/AddToCartGroupProduct";
import ProductGroupDialog from "@/components/public/products/SelectItems/ProductGroupDialog";

export default {
  name: "list-menu-group",
  props: {
    menuGroup: Object,
    drinks: Array,
    dessert: Array,
    starter: Array,
    maincourse: Array,
    isAdmin: Boolean
  },
  components: {
    AddToCartGroupProduct,
    ProductGroupDialog
  },
  methods: {
    openProductGroupDialog() {
      this.$refs.productGroupDialog.open();
    }
  }
};
</script>

<style></style>
